'use strict';

var Marionette = require('backbone.marionette');
var BaseStaticView = require('actions/shared/AbstractStaticView');
var ReservationView = require('actions/dhcpReservations/StaticReservationView');
var tpl = require('actions/dhcpReservations/static.html');
var twig = require('twig').twig;

var ReservationsListView = Marionette.CollectionView.extend({
  childView: ReservationView,
  filter: function(child, index) {
    // only show first 5 children max in static view
    return index >= 0 && index < 5;
  },
});

/**
 * Renders a text-only version of the DHCP reservations component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/dhcpReservations/StaticView#model
   * @type {actions/dhcpReservations/DhcpReservations}
   */

  template: twig({data: tpl}),

  regions: {
    rules: '.rg-reservations',
  },

  onAttach: function() {
    BaseStaticView.prototype.onAttach.apply(this, arguments);
  },

  onRender: function() {
    this.initChildViews();
  },

  /**
   * Initializes the child Views.
   */
  initChildViews: function() {
    this.showChildView('rules', new ReservationsListView({
      collection: this.model.get('items'),
    }));
  },
});
